import moment from "moment";

const timeOffset = (() => {
  const searchParams = new URLSearchParams(location.search);
  const forceDateTime = searchParams.get("forceDateTime");
  if (forceDateTime) {
    return moment(forceDateTime, "YYYYMMDDHHmmss").diff(moment(), 'seconds') * 1000;
  } else {
    return 0;
  }
})();

export const getCurrentTime = () => {
  const browserTime = new Date().getTime();
  return browserTime + timeOffset;
};



// WEBPACK FOOTER //
// ./lib/currentTime.js